import type { CSSProperties } from 'react';
import { cn } from '@worldcoo/ui/lib/utils';

/**
 * Words brighten as the block scrolls through; timing lives in `new-karaoke` in `-styles/theme.css`.
 * `text` is a string, not `children`, so inline markup is refused rather than mangled.
 */
export function Karaoke(props: { text: string; className?: string }) {
	// Keyed by word and position, since a sentence repeats words; the list only changes wholesale.
	const words = props.text
		.trim()
		.split(/\s+/)
		.map((word, index) => ({ word, index, key: `${index}-${word}` }));

	return (
		<p className={cn('new-karaoke', props.className)} style={{ '--k-n': words.length } as CSSProperties}>
			{words.map((entry) => (
				<span key={entry.key} className="new-karaoke-word" style={{ '--k-i': entry.index } as CSSProperties}>
					{entry.word}
					{entry.index < words.length - 1 ? ' ' : ''}
				</span>
			))}
		</p>
	);
}
